import { useLanguage } from '../../i18n/LanguageContext';

function RoadmapSection() {
    const { t } = useLanguage();
    const cards = [
        { title: t.roadmapStockTitle, text: t.roadmapStockDesc },
        { title: t.roadmapGoldTitle, text: t.roadmapGoldDesc },
        { title: t.roadmapLinksTitle, text: t.roadmapLinksDesc },
    ];

    return (
        <section className="home-sec" id="roadmap">
            <div className="wrap">
                <div className="launch-head rv">
                    <h2>{t.roadmapHeadTitle}</h2>
                    <p>{t.roadmapHeadLead}</p>
                </div>
                <div className="next-row">
                    {cards.map((card, index) => (
                        <div className="panel next-card rv" key={card.title} style={{ '--rv-delay': `${index * 75}ms` }}>
                            <span className="status s-next">{t.comingSoon}</span>
                            <b>{card.title}</b>
                            <span>{card.text}</span>
                        </div>
                    ))}
                    <a className="btn btn-ghost btn-sm" href="#advanced">
                        {t.advancedMarketsLink}
                    </a>
                </div>
                <div className="panel advanced-strip rv" id="advanced" style={{ '--rv-delay': '120ms' }}>
                    <div>
                        <span className="eyebrow">{t.advancedEyebrow}</span>
                        <h3>{t.advancedTitle}</h3>
                    </div>
                    <p>{t.advancedLead}</p>
                    <span className="status s-next">{t.comingLater}</span>
                </div>
            </div>
        </section>
    );
}

export default RoadmapSection;
